import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { getInputsForDynamicIntegrationOrderSearchOption, getDefaultEmail } from 'selectors/tools';
import { setDynamicOrderSearchValue } from 'actions/tools/OrdersSearchActions';
import { getDynamicOrderSearchValues } from 'selectors/tools';
import { SearchAsk, SearchInputText, SearchImageLeft } from '../../../tools/common/PageLayout.styles';
import { formatPlaceholder, formatFromSearchType } from 'util/formatUtil';
import * as searchActions from 'constants/searchActions';
import { CUSTOMER_EMAIL_SEARCH_INPUT } from 'constants/dynamicIntegrations';
import { showErrorPopup } from 'components/popups/ErrorPopup/ErrorPopup';

const MASK_TEXT = '***';

/**
 * Handles searches for dynamic integrations
 * Can optionally display multiple inputs as needed
 * Input names are set in IntegrationConfig.requiredParams
 * Unlike normal COI searches, dynamic integration params
 * are not a fixed set of known options. Instead, they and are set by operations
 */
const DTDynamicSearchBar = ({ onSearchSubmit }) => {
  const dispatch = useDispatch();

  const searchInputs = useSelector(getInputsForDynamicIntegrationOrderSearchOption);
  const defaultEmail = useSelector(getDefaultEmail);
  const dynamicOrderSearchValues = useSelector(getDynamicOrderSearchValues);

  const handleInputChange = ({ paramName, paramValue }) => {
    let newValue = paramValue;
    const isShowingMaskedDefault = newValue.includes(MASK_TEXT);
    if (isShowingMaskedDefault) {
      // If default is being edited, remove entirely and start fresh
      newValue = '';
    }

    dispatch(
      setDynamicOrderSearchValue({
        paramName,
        paramValue: newValue,
      })
    );
  };

  const handleSubmit = () => {
    const allInputsFilled =
      !isEmpty(dynamicOrderSearchValues) &&
      !isEmpty(searchInputs) &&
      Object.keys(dynamicOrderSearchValues).length === searchInputs.length &&
      Object.values(dynamicOrderSearchValues).every(Boolean);

    if (allInputsFilled) {
      return onSearchSubmit();
    }

    showErrorPopup('Please fill in all search fields', 'Oops!');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return searchInputs?.map((option, idx) => {
    const isEmail = option.varName === CUSTOMER_EMAIL_SEARCH_INPUT;
    const currentValue = dynamicOrderSearchValues?.[option.varName] ?? '';
    const defaultValue = isEmail ? defaultEmail : '';
    const displayValue =
      currentValue === defaultValue
        ? formatFromSearchType(searchActions.COMMON_ORDER_EMAIL, currentValue)
        : currentValue;
    const isLastOption = idx + 1 === searchInputs.length;
    const placeholder = option.placeholder || formatPlaceholder(option.varName);

    return (
      <SearchAsk focused={false} addBottomPadding={!isLastOption} key={placeholder}>
        <SearchImageLeft onClick={handleSubmit}>
          <img src="/images/magnifying-glass.svg" alt="magnifying-glass" />
        </SearchImageLeft>
        <SearchInputText
          value={displayValue}
          onKeyDown={handleKeyDown}
          onChange={(e) =>
            handleInputChange({
              paramValue: e.target.value,
              paramName: option.varName,
            })
          }
          placeholder={placeholder}
        />
      </SearchAsk>
    );
  });
};

export default DTDynamicSearchBar;
